import React from 'react';

import {
  AddBoxIcon,
  ClockIcon,
  ConfirmIcon,
  DeleteIcon,
  EditPenIcon,
  InfoIcon,
  LinkIcon,
  RejectIcon,
} from '@sharedCR/coreDesignSystem/icons';

import { IconSize } from 'constants/coreDesignSystem';
import { getConditionalArray } from 'utils/data';

const ICON_SIZE = IconSize[20];

export const getRowActionItems = ({
  isActionLoading,
  isLoanCanceled,
  isDeleted,
  isRejected,
  rejectionReason,
  signedOff,
  canBeSignedOff,
  canBeUnsignedOff,
  canBeRejected,
  isSignOffAllowed,
  isUnsignOffAllowed,
  isRejectAllowed,
  isManageAllowed,
  canAddTasks,
  isEditAllowed,
  isBrokerCompany,
  onSignOff,
  onUnsignOff,
  onReject,
  onEdit,
  onDelete,
  onInfo,
  onAddTasks,
  onLinkTasks,
  onRejectionReason,
  onHistory,
}) => {
  const isItemDisabled = isActionLoading || isLoanCanceled;
  const isTerminal = isDeleted || isRejected;

  const canSignOff = !isTerminal && !signedOff && canBeSignedOff && isSignOffAllowed;
  const canUnsignOff =
    !isTerminal && signedOff && canBeUnsignedOff && (isUnsignOffAllowed || isManageAllowed);
  const canReject = !isTerminal && !signedOff && canBeRejected && isRejectAllowed;
  const canEdit = !isTerminal && isEditAllowed;
  const canDelete = !isTerminal && isManageAllowed;
  const canManageTasks = !isTerminal && !signedOff && isManageAllowed && canAddTasks;

  return [
    ...getConditionalArray(isRejected && !!rejectionReason, [
      {
        text: 'Rejection Reason',
        onClick: onRejectionReason,
        icon: <InfoIcon size={ICON_SIZE} />,
      },
    ]),
    ...getConditionalArray(canSignOff, [
      {
        text: 'Sign Off',
        onClick: onSignOff,
        icon: <ConfirmIcon size={ICON_SIZE} />,
        isDisabled: isItemDisabled,
      },
    ]),
    ...getConditionalArray(canUnsignOff, [
      {
        text: 'Unsign Off',
        onClick: onUnsignOff,
        icon: <ConfirmIcon size={ICON_SIZE} />,
        isDisabled: isItemDisabled,
      },
    ]),
    ...getConditionalArray(canReject, [
      {
        text: 'Reject',
        onClick: onReject,
        icon: <RejectIcon size={ICON_SIZE} />,
        isDisabled: isItemDisabled,
      },
    ]),
    ...getConditionalArray(canEdit, [
      {
        text: 'Edit',
        onClick: onEdit,
        icon: <EditPenIcon size={ICON_SIZE} />,
        isDisabled: isItemDisabled,
      },
    ]),
    ...getConditionalArray(canDelete, [
      {
        text: 'Delete',
        onClick: onDelete,
        icon: <DeleteIcon size={ICON_SIZE} />,
        isDisabled: isItemDisabled,
      },
    ]),
    ...getConditionalArray(canManageTasks, [
      {
        text: 'Add Tasks',
        onClick: onAddTasks,
        icon: <AddBoxIcon size={ICON_SIZE} />,
        isDisabled: isItemDisabled,
      },
      {
        text: 'Link Existing Tasks',
        onClick: onLinkTasks,
        icon: <LinkIcon size={ICON_SIZE} />,
        isDisabled: isItemDisabled,
      },
    ]),
    {
      text: 'SLA Group Info',
      onClick: onInfo,
      icon: <InfoIcon size={ICON_SIZE} />,
    },
    // Change history is a lender/underwriter surface — it exposes lender-internal
    // property changes and staff identities. Keep it off broker/partner rows.
    ...getConditionalArray(!isBrokerCompany, [
      {
        text: 'History',
        onClick: onHistory,
        icon: <ClockIcon size={ICON_SIZE} />,
      },
    ]),
  ];
};
